import { createSelector } from 'reselect';
import { isNumber } from 'lodash';
import { BACKEND_KEY } from './TaxesWorkflowConstants';
import { STATES_US } from '../../CommonConstants';
import { data as dataSelector } from '../AdvWorkflow/AdvWorkflowSelector';
import { selectFeatureFlags } from '../../CommonSelectors/CommonAreaSelector';

const nullableSelectedFilingStateSelector = createSelector(
  dataSelector,
  selectFeatureFlags,
  (data, featureFlags) => {
    const featureFlag = featureFlags.find(flag => flag.name === 'CanadianProvinces');

    const serverTaxesLocationId = data(`${BACKEND_KEY}.Taxes.FilingState`);

    const states =
      featureFlag && featureFlag.enabled === false
        ? STATES_US.filter(state => !state.isCanada)
        : STATES_US;

    if (isNumber(serverTaxesLocationId)) {
      return (states.find(state => state.taxID === serverTaxesLocationId) || {}).name || null;
    }
    return null;
  },
);

export default nullableSelectedFilingStateSelector;
